// import { DialogConfirmationComponent } from '../shared/Dialogs/dialog-confirmation/dialog.confirmation.component';
// import { OnInit } from "@angular/core";
// import { Component } from "@angular/core";
// import { MatTableDataSource } from "@angular/material/table";
// import { user } from "./models/user";
// import { AdminService } from "./services/admin.service";
// import { MatDialog } from '@angular/material/dialog';
// import { ActivatedRoute, Router } from '@angular/router';
// import { MatSnackBar } from '@angular/material/snack-bar';
// import { LoggerService } from 'src/shared/logger/logger.service';
// import { Levels } from 'src/shared/logger/levels.enum';

// @Component({
//   selector: "admin-users-component",
//   templateUrl: "./users.component.html",
//   styleUrls: ["./users.component.css"]
// })
// export class AdminController implements OnInit {
//   users: user[] = [];
//   fetchingData: boolean = false;
//   displayedColumns: string[] = ['userId', 'user_upn', 'user_email', 'createdAt',
//     'updatedAt', 'createdBy', 'lastUpdatedBy', 'user_role', 'actions'];
//   tableData: MatTableDataSource<user>;

//   constructor(public adminService: AdminService, public dialog: MatDialog,
//     public router: Router, public activatedRoute: ActivatedRoute,
//     private _snackBar: MatSnackBar,
//     private loggerService: LoggerService) {
//   }

//   ngOnInit(): void {
//     this.getData();
//   }

//   applyFilter(event: Event) {
//     const filterValue = (event.target as HTMLInputElement).value;
//     this.tableData.filter = filterValue.trim().toLowerCase();
//   }


//   getData() {
//     this.fetchingData = true;
//     this.adminService.getUsers().subscribe(data => {
//       this.users = data;
//       this.tableData = new MatTableDataSource(this.users);
//       this.fetchingData = false;
//     }, err => {
//       this.fetchingData = false;
//       this.loggerService.log("AdminController", err.message, Levels.error)
//     });
//   }


//   deleteUser(userId: number) {
//     this.adminService.deleteUser(userId).subscribe(data => {
//       this.openSnackBar("User deleted successfully.", "Success");
//       this.loggerService.log("AdminController", `user with user id =${userId} deleted successfully.`, Levels.info)
//       this.getData();
//     }, err => {
//       this.openSnackBar("User does not exist.", "Error");
//       this.loggerService.log("AdminController", err.message, Levels.error)
//       this.getData();
//     })

//   }

//   sendUserToChildComponent_update(userToBeUpdated: user) {
//     this.adminService.updatedUserID.next(userToBeUpdated.id);
//     this.router.navigate(['edit'], { relativeTo: this.activatedRoute })
//   }

//   sendUserToChildComponent_activateOrDeactivateUser(userToBeUpdated: user) {
//     // this.adminService.updatedUserID.next(userToBeUpdated.id);
//     // this.router.navigate(['sendUserToChildComponent_activateOrDeactivateUser'], { relativeTo: this.activatedRoute })

//     const dialogRef = this.dialog.open(DialogConfirmationComponent, {
//       width: '450px',
//       data: { title: `${userToBeUpdated?.is_active ? "Deactivate User" : "Activate User"}`, message: "Please confirm!" },
//       disableClose: true
//     });

//     dialogRef.afterClosed().subscribe(result => {
//       if (result) {
//         userToBeUpdated.is_active = userToBeUpdated.is_active ? 0 : 1
//         this.adminService.updateUserActivationStatus(userToBeUpdated).subscribe(data => {
//           this.getData();
//           this.openSnackBar("Status updated successfully", "Success")
//           this.loggerService.log("UserEditComponent", `Status updated successfully for user with id ${userToBeUpdated.id} successfully`, Levels.info)
//         }, err => {
//           this.openSnackBar("Error has occurred try again later", "Error")
//           this.loggerService.log("UserEditComponent", err.message, Levels.error)
//         });
//       }
//     });
//   }

//   openDialog(userId: number): void {
//     const dialogRef = this.dialog.open(DialogConfirmationComponent, {
//       width: '450px',
//       data: { title: "Delete user", message: "Please confirm user deletion!" },
//       disableClose: true
//     });

//     dialogRef.afterClosed().subscribe(result => {
//       if (result) {
//         this.deleteUser(userId);
//       }
//     });
//   }


//   openSnackBar(message: string, action: string) {
//     this._snackBar.open(message, action, {
//       duration: 8000,
//       panelClass: ['mat-toolbar', 'mat-primary']
//     });
//   }

// }




// this is the old code





import { DialogSearchComponent } from './../shared/Dialogs/dialog-search/dialog.search.component';
import { DialogConfirmationComponent } from '../shared/Dialogs/dialog-confirmation/dialog.confirmation.component';
import { OnInit } from "@angular/core";
import { Component } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { user } from "./models/user";
import { AdminService } from "./services/admin.service";
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';
import { LmListsComponent } from 'src/shared/Dialogs/lm-lists/lm-lists.component';

@Component({
  selector: "admin-users-component",
  templateUrl: "./users.component.html",
  styleUrls: ["./users.component.css"]
})
export class AdminController implements OnInit {
  users: user[] = [];
  fetchingData: boolean = false;
  displayedColumns: string[] = ['userId', 'upn', 'createdAt', 'role', 'actions'];
  tableData: MatTableDataSource<user>;

  constructor(public adminService: AdminService, public dialog: MatDialog,
    public router: Router, public activatedRoute: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private loggerService: LoggerService) {
  }

  ngOnInit(): void {
    this.getData();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    //console.log(filterValue);
    this.tableData.filter = filterValue.trim().toLowerCase();
  }


  getData() {
    this.fetchingData = true;
    this.adminService.getUsers().subscribe(data => {
      //console.log(data);
      this.users = data;
      this.tableData = new MatTableDataSource(this.users);
      this.fetchingData = false;
    }, err => {
      //console.log(err);
      this.fetchingData = false;
      this.loggerService.log("AdminController", err.message, Levels.error)
    });
  }


  deleteUser(userId: number) {
    this.adminService.deleteUser(userId).subscribe(data => {
      //console.log("deleted",data);
      this.openSnackBar("User deleted successfully.", "Success");
      this.loggerService.log("AdminController", `user with user id =${userId} deleted successfully.`, Levels.info)
      this.getData();
    }, err => {
      //console.log(err);
      this.openSnackBar("User does not exist.", "Error");
      this.loggerService.log("AdminController", err.message, Levels.error)
      this.getData();
    })

  }

  sendUserToChildComponent_update(userToBeUpdated: user) {
    this.adminService.updatedUserID.next(userToBeUpdated.id);
    this.router.navigate(['edit'], { relativeTo: this.activatedRoute })
  }

  sendUserToChildComponent_resetPassword(userToBeUpdated: user) {
    this.adminService.updatedUserID.next(userToBeUpdated.id);
    this.router.navigate(['resetPassword'], { relativeTo: this.activatedRoute })
  }



  openDialog(userId: number): void {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Delete user", message: "Please confirm user deletion!" },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteUser(userId);
      }
    });
  }


  loadLMSelector(userId: number): void {

    const dialogRef = this.dialog.open(LmListsComponent, {
      //const dialogRef = this.dialog.open(DialogSearchComponent, {
      maxHeight: '100vh',
      data: {userId:userId, isEditMode:true},
      disableClose: true
    });



    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });

  }



  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });

  }







  //to be deleted just trial for other dialog
  // openDialog2(): void {

  //   const dialogRef = this.dialog.open(DialogSearchComponent, {
  //     minWidth:'700px',
  //     maxHeight: '100vh',
  //     data: [],
  //     disableClose:true,
  //   });

  //   let instance = dialogRef.componentInstance;
  //   instance.allowMultipleSelect=true;

  //   dialogRef.afterClosed().subscribe(result => {
  //     //console.log('The dialog was closed',result);
  //   });
  // }

}

